import { styled } from '@mui/material/styles';
import type { Button } from '@mui/material';
import CustomButton from './CustomButton';
import { BRAND } from '@/theme/brand-tokens';

const BRAND_ACTION_COLOR = BRAND.teal;
const BRAND_ACTION_HOVER = '#156669';

/** Primary CTA button used on dashboard headers (e.g. "New Campaign"). */
const DashboardActionButton = styled(CustomButton)(({ theme }) => ({
  '&.MuiButton-contained': {
    backgroundColor: BRAND_ACTION_COLOR,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: BRAND_ACTION_HOVER,
      opacity: 1,
    },
    '&:disabled': {
      backgroundColor: BRAND_ACTION_COLOR,
      color: theme.palette.common.white,
      opacity: 0.5,
    },
  },
})) as typeof Button;

export default DashboardActionButton;
